import { render, staticRenderFns } from "./SuggestedStartups.vue?vue&type=template&id=d759b2b4&scoped=true&"
import script from "./SuggestedStartups.vue?vue&type=script&setup=true&lang=js&"
export * from "./SuggestedStartups.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d759b2b4",
  null
  
)

export default component.exports